import React from 'react';

export const sub = (children: React.ReactNode): React.ReactElement => <sub>{children}</sub>;
export const sup = (children: React.ReactNode): React.ReactElement => <sup>{children}</sup>;
export const i = (children: React.ReactNode): React.ReactElement => <i>{children}</i>;
export const b = (children: React.ReactNode): React.ReactElement => <b>{children}</b>;
export const em = (children: React.ReactNode): React.ReactElement => <em>{children}</em>;
export const strong = (children: React.ReactNode): React.ReactElement => <strong>{children}</strong>;
